/**
 * Types for Managed Services dashboards
 */
export type MspDashboards = 'soc' | 'noc' | 'service-desk';

export const dateRangeTypes: string[] = ['Day', 'Week', 'Month', 'Year'] as const;
export type DateRangeType = (typeof dateRangeTypes)[number];

export const priorityNameTypes: string[] = [
  'Priority 1',
  'Priority 2',
  'Priority 3',
  'Priority 4',
  'Priority 5',
] as const;
export type PriorityNameType = (typeof priorityNameTypes)[number];
